module.exports = __webpack_public_path__ + "catalog/items/firesafety/Site-Evacuator/Site-Evacuator.svg";